module.exports = __webpack_public_path__ + "img/sad-goodbye.99caf4dc.svg";